import React from 'react';

// Reusable input component for budget numbers
export const BudgetInput = ({ label, id, value, onChange, readOnly, onClick, className }) => (
  <div onClick={onClick}>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700">{label}</label>
    <div className="mt-1 relative rounded-md shadow-sm">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <span className="text-gray-500 sm:text-sm">$</span>
      </div>
      <input
        type="number"
        name={id}
        id={id}
        min="0"
        className={`focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-3 sm:text-sm border-gray-300 rounded-md ${className || ''}`}
        placeholder="0.00"
        value={value}
        onChange={(e) => !readOnly && onChange(e.target.value)}
        readOnly={readOnly}
      />
    </div>
  </div>
);